import Client from './client';

export default {
  get: (page = 1, active = null) => Client.get(`/elements?page=${page}${active ? `&active=${active}` : ''}`),
  find: id => Client.get(`/elements/${id}`),
  storeElement: (data) => Client.post('/elements', data),
  updateElement: (data) => Client.put(`/elements/${data.id}`, data)
}
